import React, { useEffect, useState }  from 'react';
import Badge from '@mui/material/Badge';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DoneIcon from '@mui/icons-material/Done';
import GPAP_Button from '../../../gpap-lib/Button_Collection';

const NotificationBell = (props) => {
    
    const [open, setOpen] = useState(false);
   
    const handleClose = () => {
        setOpen(false);
    };

    const notificationHandler = (event) => {
        setOpen(true);
    }

    /*Get Select Options JSX Object*/
    const DialogMessages = () => (
        props.notificationList.map((item, index) => {
            return (
                <div>
                    <DialogTitle id="alert-dialog-title">
                        {(index + 1) + ". "}{item.title}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {item.description}
                        </DialogContentText>
                    </DialogContent>
                </div>
            );
        })
    );



    return (
        <React.Fragment>
            <Badge badgeContent={props.notificationList.length} 
                   color="primary" 
                   onClick={notificationHandler}
                   sx={{ margin:2 }}>
                <NewReleasesIcon color="action" />
            </Badge>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle> <center> Notes Release </center> </DialogTitle>
                <DialogMessages/>
                <DialogActions>
                    <GPAP_Button id="validate"  onClick={handleClose}  startIcon={<DoneIcon />}>
                        OK
                    </GPAP_Button>
                </DialogActions>
            </Dialog> 
        </React.Fragment>
    );
 }

 export default NotificationBell;